export default {
    ThisDay: 20,
    ThisWeek: 30,
    FirstWeekToPresent: 31,
    ThisMonth: 45,
    FirstMonthToPresent: 46,
    ThisYear: 500,
    FirstYearToPresent: 501,
    // Các tháng trong năm
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,
  
    // Qúy
    FiscalI: 100, // Qúy 1
    FiscalII: 200,
    FiscalIII: 300,
    FiscalIV: 400,
  
    LastWeek: 35,
    LastMonth: 50,
    LastQuarter: 65,
    LastYear: 80,
  
    NextWeek: 40,
    Next4Week: 151, // Bốn tuần sau
    NextMonth: 55,
    NextQuarter: 66,
    NextYear: 90,
    Custom: 999, // Tùy chọn báo cáo theo nghiệp vụ ( tự chọn mặc định sẽ lấy theo tháng này)
  };
  